export default {
  name: "CommentList",
  props: {
    sub: {
      type: Boolean,
      "default": false
    }
  }
};